import React from 'react';
import { useTranslation } from 'react-i18next';
import {Trans} from 'react-i18next';
import LoginLoader from "../sprite/components/login-loader/index";
import "./index.css";

const WaitingPanelPage = (props) => {
    const { t } = useTranslation();

    if(props.static){
        return (
            <div className="waiting-panel static d-flex justify-content-center align-items-center flex-column">
                <div>
                    <LoginLoader/>
                    <div className="my-5">
                        <p><Trans i18nKey="textPreparingAccountContent"/></p>
                        <p>{t("textPreparingAccountContent2")}</p>
                    </div>
                </div>
            </div>
        );
    } else {
        return (
            <div className="waiting-panel d-flex justify-content-center align-items-center flex-column">
                <div>
                    <LoginLoader/>
                    <div className="my-5">
                        <p><Trans i18nKey="textPreparingAccountContent"/></p>
                        <p>{t("textPreparingAccountContent2")}</p>
                    </div>
                </div>
            </div>
        );
    }

};

export default WaitingPanelPage;